import React from 'react';
import { MAIN_CONFIG } from '../../../config/main';

export default ({ id, className, color = MAIN_CONFIG.COLORS.fillBlue, width = "35", height = "25", secondaryColor = MAIN_CONFIG.COLORS.fillRed }) => {
    return (
        <svg id={id} className={className} width={width} height={height} viewBox="0 0 35 25" xmlns="http://www.w3.org/2000/svg">
            <title>Mastercard</title>
            <g fill="none" fillRule="evenodd">
                <rect width="35" height="25" fill="#353A48" rx="4"></rect>
                <circle cx="12.5" cy="12.5" r="7.5" fill="#ED0006"></circle>
                <circle cx="22.5" cy="12.5" r="7.5" fill="#F9A000"></circle>
                <path fill="#FF5D00" d="M17.5 6.91a7.48 7.48 0 0 1 0 11.18 7.48 7.48 0 0 1-.06-11.13z"></path>
            </g>
        </svg>
    );
};
